




































































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import TitleMixin from '@/mixins/title-mixin';
import Toast from '@/components/display/toast.vue';
import { ProductsApi } from '@/api';

@Component({
	components: {
		secondaryNav,
	},
	mixins: [TitleMixin],
})
export default class ProductView extends Vue {
	public smallScreen = window.innerWidth > 1000;

	public loading: boolean = true;
	public product: any | null = null;
	public org: any | null = null;
	public users: any[] = [];
	public generalInfo: any[] = [];

	public created() {
		this.loadProduct();
	}

	public async loadProduct() {
		const { productId } = this.$route.params;
		try {
			const { data } = await new ProductsApi().getProductById(parseInt(productId, 10), {
				params: {
					include:
						'org,alerts,notifications,notifications.user,audits,audits.user,tanks,site,faults,subscriptionitem,users,',
				},
			});

			this.product = data;
			this.org = data.org || {};

			// filter
			const alerts = [];
			if (data.alerts) {
				data.alerts.forEach(alert => {
					if (alert.subscribers && alert.subscribers.length > 0) {
						alerts.push(alert);
					}
				});
			}

			// handle other cases
			this.generalInfo = [
				{ text: 'Name', value: data.name },
				{ text: 'Status', value: data.status || '' },
				{
					text: 'Created At',
					value: this.$options.filters.longDateTime(data.createdAt) || '',
				},
				{
					text: 'Live At',
					value: this.$options.filters.longDateTime(data.liveAt),
				},
				{
					text: 'EffluTrack Phone Number',
					value: data.effluTrackPhoneNumber ? data.effluTrackPhoneNumber : '',
				},
				{
					text: 'Site',
					value: data.site ? data.site.name || '' : '',
				},
				{
					text: 'Organisation',
					value: data.org ? data.org.name || '' : '',
				},
				{
					text: 'Plan',
					value: data.subscriptionitem ? data.subscriptionitem.plan || '' : '',
				},
				{
					text: 'Trial Plan ',
					value: data.subscriptionitem ? data.subscriptionitem.trialPlan || '' : '',
				},
				{
					text: 'Trial End',
					value: this.$options.filters
						? this.$options.filters.longDateTime(
								data.subscriptionitem ? data.subscriptionitem.trialEndsAt : '',
						  ) || ''
						: '',
				},
			];
		} catch (e) {
			this.product = null;
			this.siteError = e;
			if (e.response && e.response.data && e.response.data.message) {
				this.siteError = e.response.data.message;
			}
		} finally {
			this.loading = false;
		}
	}
}
